export const classes = {
  formControl: {
    'label + &': {
      marginTop: 0,
    },
  },
};
